const initialState = {
  items: null,
  item: null,
};

const projectListReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_PROJECT_LIST_ITEMS":
      return { ...state, items: action.data };
    case "GET_PROJECT_LIST_ITEM_BY_ID":
      return { ...state, item: action.data };
    case "CREATE_PROJECT_LIST_ITEM":
    case "UPDATE_PROJECT_LIST_ITEM":
    case "DELETE_PROJECT_LIST_ITEM":
      return { ...state };
    default:
      return state;
  }
};

export default projectListReducer;
